import validate from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import business_45access_45global from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/middleware/business-access.global.js";
import navigating_45middleware_45global from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/middleware/navigating.middleware.global.js";
import support_45access_45global from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/middleware/support-access.global.js";
import manifest_45route_45rule from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  business_45access_45global,
  navigating_45middleware_45global,
  support_45access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "business-access": () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/middleware/business-access.js")
}